import React from 'react';

import TicketListContainer, {
  containerConfiguration,
} from '@totem/components/ticketing/listContainer/TicketListContainer';
import TicketsListContainerTable from '@totem/components/ticketing/listContainer/TicketListContainerTable';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';

type Props = {
  queueId: string;
  queueName: string;
};
const QueueDetails = ({ queueId, queueName }: Props) => {
  return (
    <InputContainer
      filterConfig={containerConfiguration}
      defaultSort={{
        field: 'createdAt',
        direction: 'descend',
      }}
      staticFilters={[
        {
          // Match the queue totals badge: every ticket that isn't closed.
          field: 'status',
          operator: 'nin',
          values: ['CLOSED'],
        },
        {
          field: 'queueId',
          values: [queueId],
        },
      ]}
      componentKey={`dashboard.queueDetails-${queueId}`}
    >
      <TicketListContainer>
        <IBCard title={queueName}>
          <FilterChips />
          <TicketsListContainerTable queueView />
        </IBCard>
      </TicketListContainer>
    </InputContainer>
  );
};

export default QueueDetails;
